/* tslint:disable */
/* eslint-disable */
/**
 * Agoda.PropertyOnboarding
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PropertyCard
 */
export interface PropertyCard {
    /**
     * 
     * @type {number}
     * @memberof PropertyCard
     */
    'agodaPropertyId': number;
    /**
     * 
     * @type {string}
     * @memberof PropertyCard
     */
    'onboardingId': string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyCard
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyCard
     */
    'location': string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyCard
     */
    'imageUrl': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyCard
     */
    'isPublishing': boolean;
    /**
     * 
     * @type {string}
     * @memberof PropertyCard
     */
    'lastModificationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyCard
     */
    'onboardingUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyCard
     */
    'itemStatus'?: PropertyCardItemStatusEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum PropertyCardItemStatusEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5
}


